import { updateNotes } from "@/mocks/home";

const featured = updateNotes.find((item) => item.featured) ?? updateNotes[0];
const rest = updateNotes.filter((item) => item.id !== featured.id);

export default function LatestUpdates() {
  return (
    <section id="updates" className="bg-background-50">
      <div className="mx-auto max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="reveal flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-[11px] tracking-[0.3em] text-foreground-500">
              UPDATE LOG
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[42px]">
              更新动态与线路记录
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-7 text-foreground-600">
            每一次地址轮换、线路维护与新通道上线，都会按期刊体例记录在案，方便回溯。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3">
          <article className="reveal group overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-2 lg:row-span-2">
            <div className="h-[240px] w-full md:h-[340px]">
              <img
                src={featured.image}
                alt={featured.title}
                title={`${featured.title} 黑料总站发布页`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-3">
                <span className="rounded-full bg-primary-500 px-3 py-1 font-label text-[11px] tracking-wider text-background-50">
                  {featured.kind}
                </span>
                <span className="font-label text-xs tracking-wider text-foreground-500">
                  {featured.date}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[28px]">
                {featured.title}
              </h3>
              <p className="mt-4 max-w-2xl text-sm leading-8 text-foreground-700">
                {featured.summary}
              </p>
              <button
                type="button"
                className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
              >
                阅读本期完整记录
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </article>

          {rest.map((item) => (
            <article
              key={item.id}
              className="reveal flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <div className="h-[92px] w-[92px] shrink-0 overflow-hidden rounded-md md:h-[104px] md:w-[104px]">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} 黑料总站新地址`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[10px] tracking-wider text-secondary-800">
                    {item.kind}
                  </span>
                  <span className="font-label text-[11px] text-foreground-500">
                    {item.date}
                  </span>
                </div>
                <h3 className="mt-2.5 font-heading text-base font-semibold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-6 text-foreground-600">{item.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}